import { render, staticRenderFns } from "./ProductContentSidebar.vue?vue&type=template&id=c10f3cee&scoped=true"
import script from "./ProductContentSidebar.vue?vue&type=script&lang=js"
export * from "./ProductContentSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProductContentSidebar.vue?vue&type=style&index=0&id=c10f3cee&prod&scoped=true&lang=css"
import style1 from "./ProductContentSidebar.vue?vue&type=style&index=1&id=c10f3cee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10f3cee",
  null
  
)

export default component.exports